import type { BatchAction } from 'redux-batched-actions';
import {
	fireTrackAnalytics,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import {
	type CardSetIndividualResponseFailureAction,
	type CardSetIndividualResponseSuccessAction,
	CARD_SET_INDIVIDUAL_REQUEST_SUCCESS,
	CARD_SET_INDIVIDUAL_REQUEST_FAILURE,
} from '../../../actions/card-set-request/index.tsx';
import type { State } from '../../../reducers/types.tsx';

export const setCardRequestIndividualResponse =
	(eventPrefix: string) => (preState: State, state: State, action: BatchAction) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const successActions = action.payload.filter(
			(innerAction) => innerAction.type === CARD_SET_INDIVIDUAL_REQUEST_SUCCESS,
		) as CardSetIndividualResponseSuccessAction[];

		const commonAttributes = {
			isContextualEditing: true,
		};

		if (successActions.length) {
			fireTrackAnalytics(successActions[0].meta.analyticsEvent, 'field updated', commonAttributes);
		}

		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const failureActions = action.payload.filter(
			(innerAction) => innerAction.type === CARD_SET_INDIVIDUAL_REQUEST_FAILURE,
		) as CardSetIndividualResponseFailureAction[];

		if (failureActions.length) {
			fireOperationalAnalytics(failureActions[0].meta.analyticsEvent, 'field updateFailed', {
				...commonAttributes,
				successCount: successActions.length,
				failureCount: failureActions.length,
				statusCode: failureActions[0].payload.statusCode,
			});
		}

		return { name: `${eventPrefix}.set-card-request.execute-individual.response` };
	};
